module.exports = __webpack_public_path__ + "img/logo.e0a5f8b9.svg";